export const DATA_LOAD_SUCCESS = 'data/LOAD_SUCCESS';
export const DATA_CREATE_SUCCESS = 'data/CREATE_SUCCESS';
export const DATA_EDIT_SUCCESS = 'data/EDIT_SUCCESS';
export const DATA_DELETE_SUCCESS = 'data/DELETE_SUCCESS';
export const SET_BUSY = 'data/SET_BUSY';
export const UNSET_BUSY = 'data/UNSET_BUSY';
